<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      OEM Programs
      <i class="pi pi-info-circle tooltip-field"
        pTooltip="Opts eligible OEMs into their respective programs for co-op, tracking, lead integration, and related benefits. Only one OEM program can be active at a time."
      tooltipPosition="top"></i>
    </label>
    <p-select
      formControlName="oemProgramSelect"
      [options]="oemProgramOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Select Program">
    </p-select>
  </div>

  @if (form.get('oemProgramSelect')?.value === 'FORD_DIRECT') {
    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">Ford Direct Dealer ID</label>
      <input pInputText class="dealer-id-field" type="text" formControlName="fordDirectDealerId" />
    </div>
  }

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Refresh Ad Cache
      <i class="pi pi-info-circle"
        pTooltip="Refreshes cached Offer Sets to ensure the latest data is displayed. Use when recent changes are not yet reflected."
      tooltipPosition="top"></i>
    </label>

    <div class="button-spinner-container">
      <button
        pButton
        type="button"
        class="populate-button"
        [label]="preCacheLabel"
        [icon]="preCacheIcon"
        [disabled]="preCacheBusy"
        pTooltip="Click to refresh cached Offer Sets with latest changes."
        tooltipPosition="right"
        (click)="onPreCacheClick()">
      </button>
    </div>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Email Tool Version
      <i class="pi pi-info-circle"
        pTooltip="Chooses between two versions for Offer Set and Service Special selection and styling when generating email campaigns."
      tooltipPosition="top"></i>
    </label>
    <p-select
      [options]="[{label:'Original', value:1},{label:'Newest', value:2}]"
      formControlName="emailVersion"
      optionLabel="label"
      optionValue="value">
    </p-select>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Enhanced SEO
      <i class="pi pi-info-circle"
        pTooltip="If checked, exclusive Enhanced SEO content will be pushed to the account's pages. The Enhanced SEO content is determined at the section level of OEM pages."
      tooltipPosition="top"></i>
    </label>
    <p-toggleswitch formControlName="enhancedSeoEnabled"></p-toggleswitch>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Show Dashboard Report
      <i class="pi pi-info-circle"
        pTooltip="When enabled, users land on the Account Dashboard when entering the MPOP account and can access it anytime under Reports > Dashboard."
      tooltipPosition="top"></i>
    </label>
    <p-toggleswitch formControlName="showDashboardReport"></p-toggleswitch>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Adobe Tagging
      <i class="pi pi-info-circle"
        pTooltip="Enables Adobe tagging required for Ford Direct and Stellantis OEM programs."
      tooltipPosition="top"></i>
    </label>
    <p-toggleswitch formControlName="adobeTaggingEnabled"></p-toggleswitch>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Dynamic Creative
      <i class="pi pi-info-circle"
        pTooltip="Enables Dynamic Creative for the account."
      tooltipPosition="top"></i>
    </label>
    <p-toggleswitch formControlName="dynamicCreativeEnabled"></p-toggleswitch>
  </div>

  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      <b>Beta Features</b>
    </label>
  </div>
  <div class="tab-panel-input-wrapper final-url-dropdown">
    <label class="field-input-label tab-input-label">
      Google Ads Bulk Update Tool
      <i class="pi pi-info-circle"
        pTooltip="Enable this account for early access to the Responsive Search Ad bulk update tool. Only eligible accounts can receive bulk updates. This setting is temporary and will be removed once the feature is fully rolled out."
      tooltipPosition="top"></i>
    </label>
    <p-toggleswitch formControlName="mediaAdCopyBulkUpdateEnabled"></p-toggleswitch>
  </div>
</form>
